import React from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line no-restricted-imports
import { useUpdateEventModal } from 'features/calendarEvent/update';
import { isHasAccess } from 'features/validateAccess';
import { CalendarEvent, DayTypeIcon } from 'entities/calendar';

import { formatDateRange } from 'shared/lib/dayjs';
import { UPDATE_CALENDAR } from '../../CalendarsLayout.permissions';
import styles from './CalendarPopoverContent.module.scss';

const CalendarPopoverContent = ({ event }: { event: CalendarEvent }): React.ReactElement => {
  const { t } = useTranslation();
  const { exclusionType, name, startDate, endDate } = event;
  const openModal = useUpdateEventModal();

  const canEditEvent = isHasAccess(UPDATE_CALENDAR);

  return (
    <div className={styles.container}>
      <DayTypeIcon
        type={exclusionType}
        title={
          exclusionType === 'NON_WORKING_DAY'
            ? t('Calendar:popUpContent.nonWorkingDay.text')
            : t('Calendar:popUpContent.workingDay.text')
        }
      />

      <Typography.Text className={styles.dateBlock}>{formatDateRange({ startDate, endDate })}</Typography.Text>
      <Typography.Text>{name}</Typography.Text>
      {canEditEvent && (
        <Button type="primary" className={styles.editBtn} onClick={() => openModal(event)}>
          {t('Shared:editBtn.text')}
        </Button>
      )}
    </div>
  );
};

export { CalendarPopoverContent };
